module.exports = "/cyber/_next/static/images/faq-bg-mobile-0eeb67f3692e2b900c2a6eb0bbf2f35a.jpg";